// Не используется на сервере,
// создана исключительно для фронта
export const CUSTOM_PERIOD = 'CustomPeriod';

export const TODAY = 'Today';
export const YESTERDAY = 'Yesterday';
export const LAST_WEEK = 'LastWeek';
export const LAST_MONTH = 'LastMonth';
export const LAST_THREE_MONTHS = 'LastThreeMonth';
export const LAST_N_DAYS = 'LastNDays';

export const TOMORROW = 'Tomorrow';
export const NEXT_WEEK = 'NextWeek';
export const NEXT_MONTH = 'NextMonth';
export const NEXT_THREE_MONTHS = 'NextThreeMonth';
export const NEXT_N_DAYS = 'NextNDays';

export const PERIOD = 'Period';

export const TODAY_LABEL = 'Сегодня';
export const YESTERDAY_LABEL = 'Вчера';
export const LAST_WEEK_LABEL = 'Последняя неделя';
export const LAST_MONTH_LABEL = 'Последний месяц';
export const LAST_THREE_MONTHS_LABEL = 'Последние 3 месяца';
export const LAST_N_DAYS_LABEL = 'Произвольный период';

export const TOMORROW_LABEL = 'Завтра';
export const NEXT_WEEK_LABEL = 'Следующая неделя';
export const NEXT_MONTH_LABEL = 'Следующий месяц';
export const NEXT_THREE_MONTHS_LABEL = 'Следующие 3 месяца';
export const NEXT_N_DAYS_LABEL = 'Свой период, дней';

export const ZERO_DAYS = 0;
export const ONE_DAY = 1;
export const ONE_WEEK_IN_DAYS = 7;
export const ONE_MONTH_IN_DAYS = 30;
export const THREE_MONTHS_IN_DAYS = 90;

export const PERIODS = [
  {
    id: TODAY,
    label: TODAY_LABEL,
  },
  {
    id: YESTERDAY,
    label: YESTERDAY_LABEL,
  },
  {
    id: LAST_WEEK,
    label: LAST_WEEK_LABEL,
  },
  {
    id: LAST_MONTH,
    label: LAST_MONTH_LABEL,
  },
  {
    id: LAST_THREE_MONTHS,
    label: LAST_THREE_MONTHS_LABEL,
  },
  {
    id: LAST_N_DAYS,
    label: LAST_N_DAYS_LABEL,
  },
  {
    id: TOMORROW,
    label: TOMORROW_LABEL,
  },
  {
    id: NEXT_WEEK,
    label: NEXT_WEEK_LABEL,
  },
  {
    id: NEXT_MONTH,
    label: NEXT_MONTH_LABEL,
  },
  {
    id: NEXT_THREE_MONTHS,
    label: NEXT_THREE_MONTHS_LABEL,
  },
  {
    id: NEXT_N_DAYS,
    label: NEXT_N_DAYS_LABEL,
  },
];
